const reducer = (state={forecast:{}},action)=>{
    switch(action.type){
        case 'GET_FORECAST':
            
            return({...state,forecast:action.payload})
            

        default:
            return state;

    }
}

export default reducer